export const selectOptions = (min = 0, max = 22) =>
  new Array(max + 1)
    .fill(max + 1, min, max + 1)
    .reduce((html, _, i) => (html += `<option value=${i}>${i}</option>`), '');
